import ToggleButton from '@mui/lab/ToggleButton';
import ToggleButtonGroup from '@mui/lab/ToggleButtonGroup';
import styled from 'styled-components';

import { makeNavOption, makeNavGroup } from './makeNav';

const ExclusiveToggleButtonGroup = styled(ToggleButtonGroup).attrs({
  exclusive: true,
  size: 'small',
})`
  max-height: 32px;
`;

const NAvToggleButton = styled(ToggleButton)`
  text-transform: none !important;
`;

export const NavButton = makeNavOption(NAvToggleButton);
const NavButtons = makeNavGroup(ExclusiveToggleButtonGroup);
export default NavButtons;
